import React from 'react';
const { __ } = wp.i18n;
const { InspectorControls, InnerBlocks, TextAlignmentControl } = wp.blockEditor;
const { useState, useEffect } = wp.element;
const { ToggleControl, TextControl, PanelBody, __experimentalHeading, __experimentalToggleGroupControl, __experimentalBorderBoxControl, Icon, SelectControl, __experimentalToggleGroupControlOptionIcon, __experimentalDivider, BaseControl, Flex, FlexBlock, TabPanel } = wp.components;
import {
    useBlockProps,
    useInnerBlocksProps
} from '@wordpress/block-editor';
import { useSelect } from '@wordpress/data';
import DimensionsControl from '../../controls/dimensions/dimensions.js';
import ShortUniqueId from 'short-unique-id';
import { aspectRatio } from '@wordpress/icons';
import { attributes } from '../attributes.js';
import { generateCSS, getCssCustomBlock, addAttributeResponsive, getCustomAttribute, replaceBackgroundImage } from '../functions.js';
import ColorSelector from '../../controls/color-select/color-select.js';
import BacgroundControl from '../../controls/background/background.js';
import BorderControl from '../../controls/border/border.js';
import TypographyControl from '../../controls/typography/typography.js';
import DisplayControl from '../../controls/display/display.js';
import CssCustom from '../../controls/css-custom/css-custom.js';
import SizingControl from '../../controls/sizing/sizing.js';
import CustomAttributeControl from '../../controls/custom-attribute/custom-attribute.js';
import './block-div.css';  

wp.blocks.registerBlockType('softlite-io-integration/div', {
    apiVersion: 3,
    title: __('Div'),
    icon: aspectRatio,
    category: 'softlite-io-integration',
    attributes: addAttributeResponsive(attributes),
    edit: (props) => {
        const { attributes, setAttributes } = props;
        const [css, setCss] = useState('');
        const generateID = new ShortUniqueId({ length: 8, dictionary: 'alphanum_lower' });
        const { id, htmlTag, custom_attributes } = attributes;
        const [TagName, setTagName] = useState(attributes?.htmlTag ? attributes?.htmlTag : 'div');
        const [tag, setTag] = useState(attributes?.htmlTag ? attributes?.htmlTag : 'div');
        const [linkSettings, setLinkSettings] = useState({});
        const [attributeCustom, setAttributeCustom] = useState({});
        const openTab = attributes?.state?.openTab ?? 'setting';
        const openSettingSection = attributes?.state?.openSettingSection ?? 'settings';
        const openStyleSection = attributes?.state?.openStyleSection ?? 'layout';

        const currentDevice = useSelect((select) => {
            return select('core/edit-post').__experimentalGetPreviewDeviceType();
        }, []);
        const device = currentDevice.toLowerCase();
        const deviceString = device === 'desktop' ? '' : `:${device}`;

        useEffect(() => {
            if (!id) {
                setAttributes({ id: generateID.rnd() });
            }
            const newCss = generateCSS(attributes, `softlite-block-${attributes.id}`);
            let cssCustomString = getCssCustomBlock(attributes);
            setAttributes({ css: newCss });
            let cssMerge = cssCustomString + newCss;
            cssMerge = cssMerge.replace(/#softlite-block-/g, '.softlite-block-');
            cssMerge = cssMerge.replace(/;(?![^(]*\))/g, ' !important;');
            setCss(replaceBackgroundImage(cssMerge, softliteData.site_url));
            setAttributeCustom(getCustomAttribute(custom_attributes));
        }, [attributes]);

        if(TagName == 'custom'){
            setTagName(attributes?.customTag ? attributes?.customTag : 'div');
        }

        const handleToggle = (name, type) => {
            setAttributes({state: {...attributes?.state, [type]: name === attributes?.state?.[type] ? '' : name}});
        };

        const setNewHtmlTag = (newTag) => {
            setAttributes({ htmlTag: newTag });
            setTag(newTag);
            if(newTag !== 'custom'){
                setTagName(newTag);
            }else{
                setTagName('div');
            }
        }
        const setCustomTag = (newCustomTag) => {
            setAttributes({customTag: newCustomTag});
            setTagName(newCustomTag);
        }

        const handleChangeLink = (attribute, newValue) => {
			setAttributes({
                div: {
                    ...attributes?.['div'],
                    [attribute]: attribute === 'target' ? (newValue ? '_blank' : '_self') : newValue
                }
            });

			const attributeValue = attribute === 'target' ? (newValue ? '_blank' : '') : newValue;
            
			if (attributeValue.trim() === '') {
				const newLinkSettings = { ...linkSettings };
				delete newLinkSettings[attribute];
				setLinkSettings(newLinkSettings);
			} else {
				setLinkSettings({ ...linkSettings, [attribute]: newValue });
			}
		}

        const advancedClassNames = attributes.className ? ' ' + attributes.className : '';  

        const blockProps = useBlockProps({
            className: `softlite-block-div softlite-block-${attributes.id}` + advancedClassNames,
        });

        const innerBlocksProps = useInnerBlocksProps(blockProps, {
            templateLock: false
        });

        return (
            <>
                <InspectorControls>
                    <TabPanel
                        className="softlite-tab-panel"
                        activeClass="active-tab"
                        onSelect={(newTab) => setAttributes({state: {...attributes?.state, openTab: newTab}})}
                        initialTabName={openTab}
                        tabs={[
                            {
                                name: 'setting',
                                title: 'Setting',
                                className: 'softlite-tab-setting',
                            },
                            {
                                name: 'style',
                                title: 'Style',
                                className: 'softlite-tab-style',
                            },
                        ]}  
                    >
                        {(tab) => <div>
                            {openTab == 'setting' && (
                                <PanelBody title={__('Settings')} opened={openStyleSection === 'settings'} onToggle={() => handleToggle('settings', 'openStyleSection')}>
                                    <SelectControl
                                        label="HTML Tag"
                                        value={attributes?.htmlTag}
                                        options={[
                                            { label: 'div', value: 'div' },
                                            { label: 'section', value: 'section' },
                                            { label: 'a [link]', value: 'a' },
                                            { label: 'article', value: 'article' },
                                            { label: 'nav', value: 'nav' },
                                            { label: 'ol', value: 'ol' },
                                            { label: 'ul', value: 'ul' },
                                            { label: 'li', value: 'li' },
                                            { label: 'aside', value: 'aside' },
                                            { label: 'address', value: 'address' },
                                            { label: 'figure', value: 'figure' },
                                            { label: 'Custom', value: 'custom' },
                                        ]}
                                        labelPosition="edge"
                                        className="softlite-select-control"
                                        onChange={(newTag) => setNewHtmlTag(newTag)}    
                                    />
                                    {tag == 'custom' && (
                                        <TextControl
                                            label="Custom tag"
                                            value={attributes?.customTag}
                                            onChange={(value) => setCustomTag(value)}
                                            className="softlite-text-control"
                                        />
                                    )}
                                    {tag == 'a' && (
                                        <>
                                            <TextControl
                                                label="Link"
                                                value={attributes?.div?.href}
                                                onChange={(newValue) => handleChangeLink('href', newValue)}
                                                className="softlite-text-control"
                                                placeholder="https://example.com"
                                            />
                                            <TextControl
                                                label="rel"
                                                value={attributes?.div?.rel}
                                                onChange={(newValue) => handleChangeLink('rel', newValue)}
                                                className="softlite-text-control"
                                                placeholder="nofollow"
                                            />
                                            <TextControl
                                                label="aria-label"
                                                value={attributes?.div?.['aria-label']}
                                                onChange={(newValue) => handleChangeLink('aria-label', newValue)}
                                                className="softlite-text-control"
                                                placeholder="aria-label"
                                            />
                                            <ToggleControl
                                                checked={attributes?.div?.['target'] === '_self' ? false : true}
                                                label="Open in new window"
                                                onChange={(newValue) => handleChangeLink('target', newValue)}
                                            />
                                        </>
                                    )}

                                    <DisplayControl
                                        attributes={attributes}
                                        setAttributes={setAttributes}
                                    />
                                </PanelBody>
                            )}
                            {openTab == 'style' && (
                                <>
                                    <PanelBody title={__('Layout')} opened={openStyleSection === 'layout'} onToggle={() => handleToggle('layout', 'openStyleSection')} >
                                        <__experimentalHeading>SPACING</__experimentalHeading>
                                        <label>Padding</label>
                                        <DimensionsControl
                                            attributes={attributes}
                                            setAttributes={setAttributes}
                                            attributeName="padding"
                                        />
                                        <__experimentalDivider />
                                        <label>Margin</label>
                                        <DimensionsControl
                                            attributes={attributes}
                                            setAttributes={setAttributes}
                                            attributeName="margin"
                                        />
                                        <__experimentalDivider />
                                        <SizingControl
                                            attributes={attributes} 
                                            setAttributes={setAttributes}
                                            blockName="softlite-io-integration/div"
                                        />
                                    </PanelBody>
                                    <PanelBody title={__('Typography')} opened={openStyleSection === 'typography'} onToggle={() => handleToggle('typography', 'openStyleSection')}>
                                        <TypographyControl
                                            attributes={attributes}
                                            setAttributes={setAttributes}
                                        />
                                    </PanelBody>
                                    <PanelBody title={__('Background')} opened={openStyleSection === 'background'} onToggle={() => handleToggle('background', 'openStyleSection')}>
                                        <BacgroundControl
                                            attributes={attributes}
                                            setAttributes={setAttributes}
                                        />
                                    </PanelBody>
                                    <PanelBody title={__('Border')} opened={openStyleSection === 'border'} onToggle={() => handleToggle('border', 'openStyleSection')}>
                                        <BorderControl
                                            attributes={attributes}
                                            setAttributes={setAttributes}
                                        />
                                    </PanelBody>
                                    <PanelBody title={__('Attributes')} opened={openStyleSection === 'custom-attribute'} onToggle={() => handleToggle('custom-attribute', 'openStyleSection')}>
                                        <CustomAttributeControl
                                            items={custom_attributes}
                                            onChange={(newItems) => setAttributes({ custom_attributes: newItems })}
                                        />
                                    </PanelBody>
                                    <PanelBody title={__('Custom CSS')} opened={openStyleSection === 'custom-css'} onToggle={() => handleToggle('custom-css', 'openStyleSection')}>
                                        <CssCustom
                                            attributes={attributes}
                                            setAttributes={setAttributes}
                                        />
                                    </PanelBody>
                                </>
                            )}
                        </div>}
                    </TabPanel>
                </InspectorControls>
                {/* Content Div Block */}
                <TagName{...linkSettings} {...attributeCustom} {...innerBlocksProps} />
                {css && (
                    <style type='text/css'>{css}</style>
                )}
            </>
        );
    },
    save: (props) => {
        const { attributes } = props;
        let TagName = attributes?.htmlTag || 'div';
        TagName = TagName == 'custom' ? attributes?.customTag : TagName;
        TagName = TagName ? TagName : 'div';
        let attributeCustom = getCustomAttribute(attributes?.custom_attributes);

        const linkSettings = {};

		if (attributes?.div?.href) {
			linkSettings['href'] = attributes?.div?.href;
		}
		if (attributes?.div?.target) {
			linkSettings['target'] = attributes?.div?.target;
		}
		if (attributes?.div?.['aria-label']) {
			linkSettings['aria-label'] = attributes?.div?.['aria-label'];
		}
		if (attributes?.div?.rel) {
			linkSettings['rel'] = attributes?.div?.rel;
		}

        const advancedClassNames = attributes.className ? ' ' + attributes.className : '';
        const allClassNames = `softlite-block-div${advancedClassNames}`;

        return (
            <>
                <TagName{...linkSettings} {...attributeCustom} className={allClassNames} id={`softlite-block-${attributes.id}`} >
                    <InnerBlocks.Content />
                </TagName>
            </>
        );
    },
});